export const PartsKey = 'parts';
export const PartKey = 'part-edit';
// Distinct keys for the service-context part hooks. Their response shapes
// differ from the non-service variants, so sharing a cache entry would hand
// back the wrong data whenever the same id was touched by both.
export const PartKeyForService = 'part-edit-for-service';
export const PartConditionKey = 'part-conditions';
export const PartConditionKeyForService = 'part-conditions-for-service';
export const HistoryTypesKey = 'history-types';
export const WarrantySummaryKey = 'warranty-summary';
export const PartLocationKey = 'part-location-edit';
export const PartHistoryKey = 'part-history';
export const PartExistanceKey = 'part-existance';
export const NSPartExistanceKey = 'ns-part-existance';
export const PartLocationsListKey = 'part-locations-list';
export const NSPartLocationListKey = 'ns-part-location-list';
export const MerchantDamagePartSerialDataKey = 'merchant-damage-part-serial-data';
export const PartHistoryListForServiceKey = 'part-history-list-for-service';
export const DuplicatePartsKey = 'duplicate-parts';
export const PartRepairHistory = 'part-repair-history';
export const LatestPartMomentHistory = 'latest_part_moment_history';
export const PartsLogAgainstServiceKey = 'parts-log-against-service';
